import i18next from 'i18next';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
const getDefaultState = () => {
    return {
        startsWithText: '',
        startsWithValues: [],
        notStartsWithText: '',
        notStartsWithValues: [],
    };
};
class TextFilterStartsWithNotStarts extends Component {
    constructor(props) {
        super(props);
        this.destroy = () => {
            this.setState(getDefaultState());
        };
        this.onStartsWithChanges = (event) => {
            const newValue = event.target.value;
            if (this.state.startsWithText !== newValue) {
                this.setState({
                    startsWithText: newValue,
                });
            }
        };
        this.onNotStartsWithChanges = (event) => {
            const newValue = event.target.value;
            if (this.state.notStartsWithText !== newValue) {
                this.setState({
                    notStartsWithText: newValue,
                });
            }
        };
        this.handleFilter = () => {
            const { startsWithText, notStartsWithText } = this.state;
            let startsWithValues = [];
            let notStartsWithValues = [];
            if (startsWithText) {
                startsWithValues = startsWithText
                    .replace(/\n/g, ',')
                    .split(',')
                    .map((str) => str.toLowerCase().trim())
                    .filter((str) => str.length > 0);
            }
            if (notStartsWithText) {
                notStartsWithValues = notStartsWithText
                    .replace(/\n/g, ',')
                    .split(',')
                    .map((str) => str.toLowerCase().trim())
                    .filter((str) => str.length > 0);
            }
            this.setState({ startsWithValues, notStartsWithValues }, () => {
                this.props.filterChangedCallback();
            });
        };
        this.state = getDefaultState();
    }
    getModel() {
        const { startsWithValues, notStartsWithValues } = this.state;
        const model = {};
        if (!startsWithValues.length && !notStartsWithValues.length) {
            return model;
        }
        let index = 1;
        if (startsWithValues && startsWithValues.length) {
            startsWithValues.forEach((value) => {
                model[`condition${index}`] = {
                    type: 'startsWith',
                    filter: value,
                    filterType: 'text',
                };
                index++;
            });
        }
        if (notStartsWithValues && notStartsWithValues.length) {
            notStartsWithValues.forEach((value) => {
                model[`condition${index}`] = {
                    type: 'notStartsWith',
                    filter: value,
                    filterType: 'text',
                };
                index++;
            });
        }
        return Object.assign(Object.assign({}, model), { operator: 'OR' });
    }
    setModel(model) {
        if (!model) {
            return this.setState(getDefaultState());
        }
        let startsWithValues = [];
        let notStartsWithValues = [];
        Object.keys(model).forEach((item) => {
            if (model[item].type === 'startsWith' && model[item].filter) {
                startsWithValues.push(model[item].filter);
            }
            else if (model[item].type === 'notStartsWith' && model[item].filter) {
                notStartsWithValues.push(model[item].filter);
            }
        });
        const startsWithText = startsWithValues.join('\n');
        const notStartsWithText = notStartsWithValues.join('\n');
        this.setState({ startsWithValues, notStartsWithValues, startsWithText, notStartsWithText }, () => {
            // Handle filter must be called here for some reason?!
            this.handleFilter();
        });
    }
    doesFilterPass(params) {
        if (this.props.isUsedInMultifilter) {
            // filtering order is not defined when using multifilter
            // so could not use doesRowPassOtherFilter here
            return true;
        }
        try {
            let rowPasses = false;
            const { startsWithValues, notStartsWithValues } = this.state;
            startsWithValues.forEach((val) => {
                if (this.props.valueGetter(params).toString().toLowerCase().includes(val)) {
                    rowPasses = true;
                }
            });
            notStartsWithValues.forEach((val) => {
                if (!this.props.valueGetter(params).toString().toLowerCase().includes(val)) {
                    rowPasses = true;
                }
            });
            return rowPasses;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    isFilterActive() {
        if (!this.state.startsWithText && !this.state.notStartsWithText) {
            return false;
        }
        return this.state.startsWithText.length || this.state.notStartsWithText.length;
    }
    afterGuiAttached() {
        this.focus();
    }
    focus() {
        window.setTimeout(() => {
            const container = ReactDOM.findDOMNode(this.refs.input);
            if (container) {
                container.focus();
            }
        });
    }
    render() {
        return (React.createElement("div", { className: "p-4 space-y-2" },
            React.createElement("label", { className: "mb-2 form-label" }, i18next.t('STARTS_WITH')),
            React.createElement("textarea", { rows: 5, ref: "input", value: this.state.startsWithText, onChange: this.onStartsWithChanges, className: "form-control resize-none" }),
            React.createElement("label", { className: "mb-2 form-label" }, i18next.t('NOT_STARTS_WITH')),
            React.createElement("textarea", { rows: 5, ref: "input", value: this.state.notStartsWithText, onChange: this.onNotStartsWithChanges, className: "form-control resize-none" }),
            React.createElement("div", { className: "flex justify-end pt-2" },
                React.createElement("button", { className: "button button-green", onClick: () => this.handleFilter() }, i18next.t('FILTER')))));
    }
}
export default TextFilterStartsWithNotStarts;
